import React from "react";
import { Event, PageConfigurationContextConsumer } from "./index";
import moment from "moment";
import LocationIcon from "./LocationIcon";
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";
import EventCoverPhoto from "./EventCoverPhoto";

const CompletedEventCard = ({
  event,
  showGetNotifiedPopup,
  editMode,
  eventPath,
  showUpdateEventCoverPopup
}: {
  event: Event;
  showGetNotifiedPopup: Function;
  editMode: boolean;
  eventPath: Function;
  showUpdateEventCoverPopup: Function;
}) => {
  return (
    <PageConfigurationContextConsumer>
      {pageConfiguration =>
        pageConfiguration && (
          <a
            className="event-card"
            href={eventPath(event)}
            onClick={(e: any) => {
              localStorage.setItem("isNavigatedFromOrgGallery", "true");
              if (!event.coverPhoto && !editMode) {
                e.preventDefault();
                showGetNotifiedPopup(event);
              }
            }}
          >
            <div className="completed-ev-img-div">
              <EventCoverPhoto
                event={event}
                editMode={editMode}
                pageConfiguration={pageConfiguration}
                showUpdateEventCoverPopup={showUpdateEventCoverPopup}
                className="completed-ev-img-inner-div"
              ></EventCoverPhoto>
              <div
                style={{ backgroundColor: pageConfiguration.primaryColor }}
                className={`completed-ev-date-badge ${ContrastForegroundUtility.fgClass(
                  pageConfiguration.primaryColor
                )}`}
              >
                <p className="completed-ev-date-p1">{event.day}</p>
                <p className="completed-ev-date-p2">{event.month}</p>
                <p className="completed-ev-date-p3">{event.year}</p>
              </div>
            </div>
            <div className="completed-ev-info-div">
              <p className="completed-ev-info-head">{event.name}</p>
              <p className="completed-ev-info-p"></p>
            </div>
            <div className="completed-ev-location-div">
              <div className="location-pin-img">
                <LocationIcon color={pageConfiguration.primaryColor} />
              </div>
              <div>
                <p className="completed-ev-location-p1">{event.location}</p>
                <p className="completed-ev-location-p2">{event.country}</p>
              </div>
            </div>
          </a>
        )
      }
    </PageConfigurationContextConsumer>
  );
};

export default CompletedEventCard;
